"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var workflow_1 = require("@newfront-insurance/workflow");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var policy_change_status_selector_1 = __importDefault(require("../components/policy-change-status-selector"));
var schemas_1 = require("../lib/schemas");
function CancellationPolicyChange(_a) {
    var onBack = _a.onBack, onSubmit = _a.onSubmit, context = _a.context, initialBillingChanges = _a.initialBillingChanges;
    var form = formik_1.useFormik({
        initialValues: {
            primaryReason: context.primaryReason,
            secondaryReason: context.secondaryReason,
            effectiveDate: context.effectiveDate,
            notes: context.notes,
            billingChanges: initialBillingChanges,
            status: 'Pending',
        },
        validationSchema: schemas_1.verifyThirdStepSchema,
        onSubmit: onSubmit,
        validateOnMount: true,
    });
    var values = form.values, onChange = form.setFieldValue;
    return (react_1.default.createElement("form", { onSubmit: form.handleSubmit },
        react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(core_ui_1.Card, null,
                react_1.default.createElement(workflow_1.WorkflowContent.Header, { title: "Create a policy change to complete the cancellation" }),
                react_1.default.createElement(workflow_1.WorkflowContent.Body, null,
                    react_1.default.createElement(core_ui_1.Spacing, { height: 32 }),
                    react_1.default.createElement(core_ui_1.Stack, { direction: "vertical", gap: 24 },
                        react_1.default.createElement(core_ui_1.Columns, { gap: 24 },
                            react_1.default.createElement(core_ui_1.Field, { fieldId: "effectiveDate", label: "Effective date of change*", hint: "This will be used as the policy's cancellation effective date" },
                                react_1.default.createElement(core_ui_1.DatePickerInput, { name: "effectiveDate", initValue: form.initialValues.effectiveDate, format: "YYYY-MM-DD", onChange: function (e) { return onChange('effectiveDate', e); } })),
                            react_1.default.createElement(core_ui_1.Field, { fieldId: "status", label: "Status*" },
                                react_1.default.createElement(policy_change_status_selector_1.default, { onChange: function (e) { return onChange('status', e); }, value: values.status, isRequired: true }))),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "description", label: "Describe the policy change" },
                            react_1.default.createElement(core_ui_1.Input, { type: "textarea", onChange: function (e) { return onChange('notes', e); }, height: 200, value: values.notes })),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "billingChanges", label: "Are there any policy billing changes?", hint: "Tip: You can enter expressions like '100+200-10' and the value will be calculated for you." },
                            react_1.default.createElement(core_ui_1.BillingChangeSpreadsheet, { value: values.billingChanges, onChange: function (e) { return onChange('billingChanges', e); } })))),
                react_1.default.createElement(workflow_1.WorkflowContent.Footer, { actions: {
                        back: {
                            type: 'button',
                            text: 'Back',
                            onClick: function () { return onBack(values); },
                        },
                        next: {
                            type: 'submit',
                            text: 'Cancel Policy',
                            loading: form.isSubmitting,
                            disabled: !form.isValid || form.isSubmitting,
                        },
                    } })))));
}
exports.default = CancellationPolicyChange;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 900px;\n  margin: 0 auto;\n"], ["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 900px;\n  margin: 0 auto;\n"])));
var templateObject_1;
